var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showNestedTable)?_c('MTableRow',_vm._b({staticClass:"m-table-nested-row",attrs:{"is-nested":true}},'MTableRow',_vm.$props,false),[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }